// @ts-nocheck
import React from "react";
import { Container } from "./styles";
import { dataEtapas, etapaPorStep } from "../../../data/dataEtapas";
import { isPlano2026, taxaConservatoria } from "../../../helpers/process.helper";

// "2026-09-29T00:00:00.000000Z" -> "29/09" (sem converter fuso)
const diaMes = (data) => {
  const [, mes, dia] = String(data).slice(0, 10).split("-");
  return dia && mes ? `${dia}/${mes}` : null;
};

// Data de chegada do documento mais recente do processo.
const ultimaChegada = (documentos) => {
  const datas = (documentos || [])
    .map((d) => d?.arrived_date)
    .filter(Boolean)
    .map((d) => String(d).slice(0, 10))
    .sort();
  return datas.length ? diaMes(datas[datas.length - 1]) : null;
};

// Bloco fixo no topo do card: o que está acontecendo, o que depende do
// cliente e quanto costuma demorar, conforme a etapa.
export default function EtapaResumo({ process, complete }) {
  let chave = complete ? "concluido" : etapaPorStep[process?.step?.name];
  if (chave === "despacho" && isPlano2026(process?.sale?.family_plan)) {
    const taxa = taxaConservatoria(process?.type);
    if (taxa.modo === "link") chave = "despacho2026";
    else if (taxa.modo === "equipe") chave = "despacho2026Equipe";
  }
  const textos = dataEtapas[chave];
  if (!textos) return null;

  let { acontecendo } = textos;
  if (chave === "analise") {
    const chegada = ultimaChegada(process?.service_documents);
    if (chegada) {
      acontecendo = `${acontecendo.replace(/\.$/, "")} que chegou em ${chegada}.`;
    }
  }

  return (
    <Container>
      <p>
        <b>Acontecendo:</b> {acontecendo}
      </p>
      <p>
        <b>Depende de você:</b> {textos.depende}
      </p>
      <p>
        <b>Quanto demora:</b> {textos.demora}
      </p>
    </Container>
  );
}
